// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { attachableChargeSchema } from '@/billing/api/get-attachable-charges';
import { dateSchema } from '@/utilities/date-time-schema';
import { z } from 'zod';

export const addLineItemFormSchema = z
  .object({
    charge: attachableChargeSchema.nullable(),
    billingEligibleDate: dateSchema,
  })
  .refine((value) => value.charge !== null, {
    message: 'Charge is required',
    path: ['charge'],
  });

export type AddLineItemFormData = z.infer<typeof addLineItemFormSchema>;
